import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalType, LeadFormData } from '@core/models/modal.model';
import { AdminService } from './admin.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private adminService = inject(AdminService);
  private router = inject(Router);
  private location = inject(Location);

  isModalOpen: boolean = false;
  modalType: ModalType = 'signin';
  activeMode: 'signin' | 'signup' = 'signin';
  modalSubmitted: boolean = false;
  submittedSuccessMsg: string = '';
  loginError: string = '';
  isLoggingIn: boolean = false;

  formData: LeadFormData = {
    username: '',
    password: '',
    rememberMe: true,
    companyName: '',
    contactName: '',
    phone: '',
    role: 'Executive Chef / Kitchen Lead',
    city: '',
    requirement: ''
  };

  openModal(type: ModalType = 'signin'): void {
    this.modalType = type;
    if (type === 'portal' || type === 'signin') {
      this.activeMode = 'signin';
      this.location.go('/login');
    } else {
      this.activeMode = 'signup';
    }
    this.modalSubmitted = false;
    this.loginError = '';
    this.isModalOpen = true;
  }

  switchMode(mode: 'signin' | 'signup'): void {
    this.activeMode = mode;
    this.modalSubmitted = false;
    this.loginError = '';
  }

  closeModal(skipUrlReset = false): void {
    this.isModalOpen = false;
    this.modalSubmitted = false;
    this.loginError = '';
    if (!skipUrlReset && (this.router.url.includes('/login') || window.location.pathname.includes('/login'))) {
      this.location.go('/');
    }
  }

  handleFormSubmit(event: Event): void {
    event.preventDefault();
    if (this.activeMode === 'signin') {
      this.submitLogin();
    } else {
      this.submittedSuccessMsg = 'Thank you! Our enterprise onboarding manager will provide platform credentials and daily harbor rate cards.';
      this.modalSubmitted = true;
    }
  }

  private submitLogin(): void {
    const email = (this.formData.username || '').trim();
    const password = this.formData.password || '';
    if (!email || !password) {
      this.loginError = 'Please enter both an email and a password.';
      return;
    }

    this.loginError = '';
    this.isLoggingIn = true;
    this.adminService.login(email, password).subscribe({
      next: () => {
        this.isLoggingIn = false;
        this.closeModal(true);
      },
      error: (error: unknown) => {
        this.isLoggingIn = false;
        this.loginError = error instanceof HttpErrorResponse && error.status === 401
          ? 'Invalid email or password. Please try again.'
          : 'Sign in failed. Please check your connection and try again.';
      }
    });
  }

  showSubscribeSuccess(): void {
    alert('Thank you for subscribing to Fresply Daily Harbor Rate Card!');
  }
}
